import DynamicComponent from "./DynamicComponent";
import { renderDynamicComponent } from "./DynamicComponent.utils";
import type { GlobalComponentContent, SBComponents, SBComponent, RegularComponent } from "./DynamicComponent.d";

export { DynamicComponent, renderDynamicComponent };
export type { GlobalComponentContent, SBComponents, SBComponent, RegularComponent };
